import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import CoreMap from '@bd/bdui-coremap';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import Filters from './Filters';
import CommunityCard from '../components/CommunityCard';
import { colors } from '../styles';

const styles = css`
  .Communities_communitiesResults {
    position: relative;
    z-index: 1;
    border-bottom:1px solid #ddd;
    @media (min-width: 992px) {
      display: flex;
      flex-flow:row-reverse wrap;
      height: calc(100vh - 420px);
      height:600px;
    }
  }

  .Communities_communitiesList {
    position: relative;
    background-color:white;
    z-index: 1;
    height: auto;
    width: 100%;
    @media (max-width: 991px) {
      &.Communities_communitiesList--hide {
        display: none;
      }
    }
    @media (min-width: 992px) {
      width: 440px;
      overflow-y: scroll;
      margin-top: 0;
      height:100%;
    }
    ul {
      margin:0;
    }
  }
  .ShowMap_button {
    position: absolute;
    background-color: ${colors.color2};
    display:none;
  }
`;

const communityMap = css`
  position: relative;
  width: 100%;
  z-index: 0;

  @media (min-width: 992px) {
    width: auto;
    flex-grow: 1;
  }
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content-wrapper {
    border-radius: 0;
    width: 250px;
    .CommunityCard_wrapper {
      width: 100% !important;
    }
    .CommunityCard_inner {
      flex-direction: column !important;
    }
    .CommunityCard_mapButton {
      display: none !important;
    }
    .CommunityCard_detailButton {
      width: 100% !important;
    }
    .CommunityCard_buttonWrapper {
      margin: 0 !important;
    }
    .CommunityCard_priceValue {
      padding: 10px 8px !important;
    }
    .leaflet-popup-content {
      margin:0;
      width:100% !important;

      p {
        margin-top: 0;
      }
    }
  }
  .Communities_legend {
    position: absolute;
    top: 10px;
    right:10px;
    background:white;
    padding:5px;
    display: flex;
    flex-flow:row wrap;
    justify-content: center;
    z-index:99999;

    li {
      margin-right:10px;
    }
    li:last-child {
      margin-right:0;
    }
  }
`;

function CommunityResults({ activeMapPin, communities, sort, showMap }) {
  const soldCommunities = communities.filter(item => item.status === 'Sold Out' && !get(item, 'hide_from_results', false));
  const newCommunities = communities.filter(item => item.status !== 'Sold Out' && !get(item, 'hide_from_results', false));
  return (
    <div className={styles}>
      <div className="Communities_communitiesResults">
        <CoreMap
          animate
          useFlyTo
          boundsOptions={{ animate: true, duration: 0.5 }}
          pin={{
            iconUrl: '/images/icon-map-pin-green.svg',
            iconSize: [36, 50],
            iconAnchor: [18, 50],
            popupAnchor: [0, -25],
          }}
          pins={[
            {
              iconUrl: '/images/icon-map-pin.svg',
              when: marker => get(marker, 'status') === 'Sold Out',
            },
            {
              iconUrl: '/images/icon-map-pin-blue.svg',
              when: marker => get(marker, 'status') === 'Coming Soon',
            },
          ]}
          activePin={activeMapPin}
          className={communityMap}
          markers={communities}
          popup={({ marker: community }) => (
            <CommunityCard community={community} />
          )}
        >
          <ul className="list-unstyled Communities_legend">
            <li><img src="/images/icon-map-pin-green.svg" width="16" height="23" alt="map legend active" /> Active</li>
            <li><img src="/images/icon-map-pin-blue.svg" width="16" height="23" alt="map legend coming soon" /> Coming Soon</li>
            <li><img src="/images/icon-map-pin.svg" width="16" height="23" alt="map legend sold out" /> Sold Out</li>
          </ul>
        </CoreMap>
        <div className={`Communities_communitiesList ${showMap ? 'Communities_communitiesList--hide' : ''}`}>
          <Filters
            type="communities"
            filterOptions={[
              {
                type: 'SingleSelect',
                filter: 'Area',
                title: 'Filter by City',
                placeholder: 'All Cities',
                routeParam: 'communityMarketArea',
                onlyFilters: [],
              },
            ]}
          />
          <ul className="list-unstyled">
            {
              orderBy(newCommunities, sort.field, get(sort, 'dir', 'asc')).map(community => (
                <li key={community._id}>
                  <CommunityCard community={community} />
                </li>
              ))
            }
            {
              orderBy(soldCommunities, sort.field, get(sort, 'dir', 'asc')).map(community => (
                <li key={community._id}>
                  <CommunityCard community={community} />
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    </div>
  );
}

CommunityResults.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeMapPin: PropTypes.string,
  sort: PropTypes.object,
  showMap: PropTypes.bool.isRequired,
};

CommunityResults.defaultProps = {
  activeMapPin: undefined,
  sort: {},
};

export default withData({
  communities: true,
})(CommunityResults);



// WEBPACK FOOTER //
// ./src/components/CommunityResults.js